import { Injectable } from '@angular/core';
import { ServiceTypeDto } from '@interfaces/ServiceTypeDto';
import { EstimateService } from '@shared/services/estimate.service';
import { lastValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ServiceTypePickerService {
  private serviceTypes$: Promise<ServiceTypeDto[]>;

  public constructor(private estimateService: EstimateService) {}

  public getServiceTypes() {
    if (!this.serviceTypes$) {
      this.serviceTypes$ = this._getServiceTypes();
    }

    return this.serviceTypes$;
  }

  private async _getServiceTypes() {
    const serviceTypes = await lastValueFrom(this.estimateService.getServiceTypes());

    return serviceTypes;
  }

  public async getServiceTypeByCode(code: string) {
    const serviceTypes = await this.getServiceTypes();

    return serviceTypes.find(st => st.code === code);
  }
}
